import * as React from 'react';

import Spinner from 'components/spinner/spinner.component';
import { IDispatchProps, IStateProps } from './check-authentication.container';

class CheckAuthentication extends React.Component<ICheckAuthenticationProps> {
    private WAIT_FOR_TRANSITION_TIMEOUT: number;

    /* TODO: This's temporary solution to be deprecated after
    *  https://gitlab-ncsa.ubisoft.org/Sitegen/sitegen-main/issues/113 is implemented
    *  In case of remounting in embedded mode with initialized Connect SDK
    *  subscription on session requests doesn't fire
    * */
    public componentDidMount(): void {
        this.WAIT_FOR_TRANSITION_TIMEOUT = window.setTimeout(this.props.goToLandingPage, 10 * 1000);
        if (!this.props.fetching) {
            this.props.requestLoginSession();
        }
    }

    public componentDidUpdate() {
        window.clearTimeout(this.WAIT_FOR_TRANSITION_TIMEOUT);

        if (this.props.fetching) {
            return;
        }

        return this.props.session
            ? this.props.goToGetBetaInfo()
            : this.props.goToLandingPage();
    }

    public render() {
        return <Spinner />;
    }
}

interface ICheckAuthenticationProps extends IDispatchProps, IStateProps {}

export default CheckAuthentication;
